export default {
  minority: 'Minority owned business',
  woman: 'Woman owned business',
  disabled: 'Disabled owned business',
  veteran: 'Veteran owned business',
};
